import { IonCard, IonIcon } from '@ionic/react'
import { ModalOption } from '@vae/server/src/types/notifications'
import { chevronForward } from 'ionicons/icons'
import React, { useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { ModalContext } from '../../../contexts/ModalContext'

interface Props {
	children: React.ReactNode
	linkTarget?: string
	linkModalTarget?: ModalOption
	onClick?: () => void
	className?: string
	headerText: string
	headerSubtext?: React.ReactNode | string
	disableChevron?: boolean
	icon: any
	iconType?: 'mui' | 'ionic'
	disableDivider?: boolean
}

const OverViewCard: React.FC<Props> = ({
	children,
	linkTarget,
	linkModalTarget,
	onClick,
	className,
	icon,
	iconType = 'ionic',
	headerText,
	headerSubtext,
	disableChevron,
}) => {
	const { insertModal } = useContext(ModalContext)
	const history = useHistory()

	return (
		<IonCard
			className={`${className === 'gradient' ? 'border border-brand-primary-100-light dark:border-brand-primary-100-dark dark:bg-[linear-gradient(75deg,_#3cb49f_0%,_#cae3cc_100%)] bg-[linear-gradient(75deg,_#d6e4ff_0%,_#c9f7d3_100%)]' : className} overview-card shadow-card bg-white dark:bg-background-200-dark`}
		>
			<div
				onClick={() => {
					if (linkTarget) {
						history.push(linkTarget)
					} else if (linkModalTarget) {
						insertModal(linkModalTarget)
					} else if (onClick) {
						onClick()
					}
				}}
				className='header'
			>
				<div className='icon-container bg-brand-primary-200-light text-brand-primary-100-light dark:bg-brand-primary-200-dark dark:text-brand-secondary-100-dark'>
					{iconType === 'ionic' ? <IonIcon icon={icon} /> : icon}
				</div>
				<div
					className={`texts ${className === 'gradient' ? 'dark:text-brand-primary-200-dark text-text-dark' : 'text-text-dark dark:text-white'}`}
				>
					<div className='tracking-wide'>{headerText}</div>
					{headerSubtext && <div className='sub-header'>{headerSubtext}</div>}
				</div>
				{disableChevron === undefined && (
					<div className='chevron-container button-hover bg-background-100-light dark:bg-surface-dark'>
						<IonIcon icon={chevronForward} />
					</div>
				)}
			</div>

			{children}
		</IonCard>
	)
}
export default OverViewCard
